import { cloneElement, ReactElement } from 'react';

import { reportPendo } from '../../utils/setupPendo';

export default (props: {
  children: ReactElement;
  method?: string | symbol;
  type: string;
  metadata?: any;
  flush?: boolean;
}) => {
  const method = props.method || 'onClick';
  const childProps = props.children.props;
  if (
    !(childProps[method] instanceof Function) &&
    childProps[method] !== null &&
    childProps[method] !== undefined
  ) {
    return props.children;
  }

  return cloneElement(props.children, {
    ...childProps,
    [method]: (...args: any[]) => {
      reportPendo(props.type, props.metadata, props.flush || true);
      if (childProps[method] instanceof Function) {
        childProps[method](...args);
      }
    },
  });
};
